import axios from 'axios'

export default {
  namespaced: true,
  state: {
    wallets: []
  },
  mutations: {
    SET_WALLET (state, data) {
      state.wallets = data
    }
  },
  getters: {
  },
  actions: {
    async get ({ commit }, data) {
      let p = _.map(data.params, (v, k) => encodeURIComponent(k) + '=' + encodeURIComponent(v)).join('&')
      let response = await axios.get(`/agents/${data.id}/wallet/?${p}`)
      commit('SET_WALLET', response.data)
    },
    async create ({ commit }, data) {
      let response = await axios.post(`/agents/${data.id}/wallet`, data.data)
      return response
    },
    async update ({ commit }, params) {
      let response = await axios.patch(`/agents/${params.uid}/wallet/${params.wid}`, { params: params.data })
      return response
    },
    async delete ({ commit }, params) {
      let response = await axios.delete(`/agents/${params.uid}/wallet/${params.wid}`)
      return response
    }
  }
}
